// extracted by mini-css-extract-plugin
export var aiStarIcon = "_eg-4";
export var closeButton = "_eg-6";
export var dismissButton = "_eg-3";
export var editImageWithAiContainer = "_eg-8";
export var imageUploadWrapper = "_eg-7";
export var misspelledWord = "_eg-5";
export var spellCheckContainer = "_eg-2";
export var spin = "_eg-1";
export var spinning = "_eg-0";